module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.fef2e08e.ttf";